import React, { useState, useRef, useEffect } from 'react';

export function CnInput({ value, onChange, placeholder, style, type }) {
  const composing = useRef(false);
  const [local, setLocal] = useState(value || '');

  useEffect(() => {
    if (!composing.current) setLocal(value || '');
  }, [value]);

  return (
    <input
      type={type || 'text'}
      value={local}
      placeholder={placeholder}
      style={style}
      onChange={e => {
        setLocal(e.target.value);
        if (!composing.current) onChange(e.target.value);
      }}
      onCompositionStart={() => { composing.current = true; }}
      onCompositionEnd={e => {
        composing.current = false;
        setLocal(e.target.value);
        onChange(e.target.value);
      }}
    />
  );
}

export function CnTextarea({ value, onChange, placeholder, style, rows }) {
  const composing = useRef(false);
  const [local, setLocal] = useState(value || '');

  useEffect(() => {
    if (!composing.current) setLocal(value || '');
  }, [value]);

  return (
    <textarea
      value={local}
      placeholder={placeholder}
      style={style}
      rows={rows || 3}
      onChange={e => {
        setLocal(e.target.value);
        if (!composing.current) onChange(e.target.value);
      }}
      onCompositionStart={() => { composing.current = true; }}
      onCompositionEnd={e => {
        composing.current = false;
        setLocal(e.target.value);
        onChange(e.target.value);
      }}
    />
  );
}
